<!-- 答题区域 -->
<template>
<div class="m-answer-area">
    <div class="question-item" v-for="(item, i) in questioninfo" :key="item.innerid">
        <div class="questiontype-subject">
            <div class="questiontype" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ item.questiontypename }}</div>
            <div class="subject" :style="{fontSize: '0.' + fontSize + 'rem'}" v-html="item.subject"></div>
        </div>
        <div class="radio-group-box" v-if="item.editable && (item.questiontype === 1 || item.questiontype === 4)">
            <div class="radio-item" :class="{active: option.optionsvalue === item.uselanswer}" @click="handleRadioSelect(option, item)" v-for="(option) in item.optionslist" :key="option.optionsvalue">
                <div class="optionsvalue" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ item.questiontype === 4 ? option.optionsshowvalue : option.optionsvalue}}</div>
                <div class="optionsinfo" :style="{fontSize: '0.' + fontSize + 'rem'}" v-html="option.optionsinfo"></div>
            </div>
        </div>
        <div class="radio-group-box read-only" v-if="!item.editable && item.questiontype === 1">
            <div class="radio-item" v-for="(option) in item.optionslist" :key="option.optionsvalue">
                <div class="is-correct" v-if="option.isrightanswer">
                    <div class="value" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsvalue }}</div>
                </div>
                <div class="is-error" v-else-if="item.uselanswer === option.optionsvalue">
                    <div class="value" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsvalue }}</div>
                </div>
                <div class="optionsvalue" :style="{fontSize: '0.' + fontSize + 'rem'}" v-else>{{ option.optionsvalue }}</div>
                <div class="optionsinfo" :class="{correct: option.isrightanswer, iserror: !option.isrightanswer && item.uselanswer === option.optionsvalue}" :style="{fontSize: '0.' + fontSize + 'rem'}" v-html="option.optionsinfo"></div>
            </div>
        </div>
        <div class="radio-group-box read-only" v-if="!item.editable && item.questiontype === 4">
            <div class="radio-item" v-for="(option) in item.optionslist" :key="option.optionsvalue">
                <div class="is-correct" v-if="item.finalanswer === option.optionsvalue">
                    <div class="value" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsshowvalue }}</div>
                </div>
                <div class="is-error" v-else-if="item.uselanswer === option.optionsvalue">
                    <div class="value" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsshowvalue }}</div>
                </div>
                <div class="optionsvalue" :style="{fontSize: '0.' + fontSize + 'rem'}" v-else>{{ option.optionsshowvalue }}</div>
                <div class="optionsinfo" :class="{correct: item.finalanswer === option.optionsvalue, iserror: item.finalanswer !== option.optionsvalue && item.uselanswer === option.optionsvalue}" :style="{fontSize: '0.' + fontSize + 'rem'}" v-html="option.optionsinfo"></div>
            </div>
        </div>
        <div class="radio-group-box" v-if="item.editable && item.questiontype === 2">
            <div class="radio-item" :class="{active: item.uselanswer.indexOf(option.optionsvalue) !== -1}" @click="handleCheckboxSelect(option, item)" v-for="(option) in item.optionslist" :key="option.optionsvalue">
                <div class="optionsvalue" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsvalue }}</div>
                <div class="optionsinfo" :style="{fontSize: '0.' + fontSize + 'rem'}" v-html="option.optionsinfo"></div>
            </div>
        </div>
        <div class="submit-answer-btn-box" v-if="item.editable && item.questiontype === 2 && item.uselanswer.length">
            <div class="submit-answer-btn" @click="handleSaveExamQuestionItem(item, true)">提交答案</div>
        </div>
        <div class="radio-group-box read-only" v-if="!item.editable && item.questiontype === 2">
            <div class="radio-item" v-for="(option) in item.optionslist" :key="option.optionsvalue">
                <div class="is-correct" v-if="option.isrightanswer">
                    <div class="value" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsvalue }}</div>
                </div>
                <div class="is-error" v-else-if="item.uselanswer.indexOf(option.optionsvalue) !== -1">
                    <div class="value" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ option.optionsvalue }}</div>
                </div>
                <div class="optionsvalue" :style="{fontSize: '0.' + fontSize + 'rem'}" v-else>{{ option.optionsvalue }}</div>
                <div class="optionsinfo" :class="{correct: option.isrightanswer, iserror: !option.isrightanswer && item.uselanswer === option.optionsvalue}" :style="{fontSize: '0.' + fontSize + 'rem'}" v-html="option.optionsinfo"></div>
            </div>
        </div>
        <div class="answer-box" v-if="!item.editable">
            <div class="answer-item">
                <div class="label" :style="{fontSize: '0.' + (fontSize - 4) + 'rem'}">参考答案</div>
                <div class="value is-correct" :style="{fontSize: '0.' + fontSize + 'rem'}">{{ item.questiontype === 4 ? (item.finalanswer === 'T' ? '正确' : '错误') : item.finalanswer }}</div>
            </div>
            <div class="answer-item">
                <div class="label" :style="{fontSize: '0.' + (fontSize - 4) + 'rem'}">您的答案</div>
                <div class="value" :class="[item.userscore ? 'is-correct' : 'is-error']"  :style="{fontSize: '0.' + fontSize + 'rem'}">{{ item.questiontype === 2 ? item.uselanswer.join('') : (item.questiontype === 4 ? (item.uselanswer === 'T' ? '正确' : (item.uselanswer === 'F' ? '错误' : '')) : item.uselanswer) }}</div>
            </div>
        </div>
        <div class="analysis-box" v-if="!item.editable">
            <div class="icon-title">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/analysis_icon.png')" />
                <div class="title" :style="{fontSize: '0.' + fontSize + 'rem'}">答案解析</div>
            </div>
            <div class="quesanalysis" v-html="item.quesanalysis" :style="{fontSize: '0.' + fontSize + 'rem'}"></div>
        </div>
    </div>
</div>
</template>

<script>
import {saveExamRecord} from '@/api/questionbank.js'
import {saveTopicUserExamQuestionResultBySpecial} from '@/api/specialTopic.js'
export default {
    data() {
        return {

        }
    },
    props: {
        examinfo: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },
        questioninfo: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        pattern: {
            type: Number,
            required: true,
            default: 1
        },
        fontSize: {
            type: Number,
            required: true,
            default: 16
        },
        submitAutoJump: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleSaveExamQuestionItem(item, showTips) {
            if (this.$route.params.examsource == 1 || this.$route.params.examsource == 2 || this.$route.params.examsource == 3 || this.$route.params.examsource == 4) {
                this.handleSaveExamRecord(item, showTips)
            } else if (this.$route.params.examsource == 5 || this.$route.params.examsource == 6) {
                this.handleSaveTopicUserExamQuestionResultBySpecial(item, showTips)
            }
        },
        handleSaveExamRecord(item, showTips) {
            let params = {
                exampid: this.$route.query.examid,
                anmode: 2,
                questioninfo: JSON.stringify([{
                    innerid: item.innerid,
                    questionindex: item.questionindex,
                    questiontype: item.questiontype,
                    uselanswer: item.questiontype === 2 ? item.uselanswer.join(',') : item.uselanswer,
                    questioninfo: [
                        {
                            innerid: item.innerid,
                            questiontype: item.questiontype,
                            uselanswer: item.questiontype === 2 ? item.uselanswer.join(',') : item.uselanswer
                        }
                    ]
                }])
            }
            saveExamRecord({
                data: params,
                success: data => {
                    if (this.pattern === 2) {
                        item.editable = false
                    }
                    item.issubmit = 1
                    let emitData = {
                        innerid: item.innerid,
                        answerstatus: item.uselanswer === item.finalanswer ? 1 : 0,
                        status: 1,
                        issubmit: 1
                    }
                    if (item.questiontype === 2) {
                        let answerstatus = 1
                        item.uselanswer.some(option => {
                            if (item.finalanswer.indexOf(option) === -1) {
                                answerstatus = 0
                                return true
                            }
                        })
                        emitData.answerstatus = answerstatus
                    }
                    if (emitData.answerstatus) {
                        item.userscore = 1
                    } else {
                        item.userscore = 0
                    }
                    if (showTips && !this.submitAutoJump) {
                        this.$toast.success('提交成功！')
                    }
                    this.$emit('handleSaveExamQuestionSuccess', emitData)
                },
                error: error => {

                }
            })
            if (this.submitAutoJump) {
                this.$emit('handleNextPage')
            }
        },
        handleSaveTopicUserExamQuestionResultBySpecial(item, showTips) {
            let params = {
                datasource: this.$route.params.examsource == 5 ? 2 : 1,
                keycode: item.keycode,
                questiontype: item.questiontype,
                useranswer: item.questiontype === 2 ? item.uselanswer.join(',') : item.uselanswer,
                userexamquestioncode: item.innerid
            }
            saveTopicUserExamQuestionResultBySpecial({
                data: params,
                success: data => {
                    item.editable = false
                    item.issubmit = 1
                    let emitData = {
                        innerid: item.keycode,
                        answerstatus: Number(data.data),
                        status: 1,
                        issubmit: 1
                    }
                    if (emitData.answerstatus) {
                        item.userscore = 1
                    } else {
                        item.userscore = 0
                    }
                    if (showTips && !this.submitAutoJump) {
                        this.$toast.success('提交成功！')
                    }
                    // if (item.questiontype === 2) {
                    //     let answerstatus = 1
                    //     item.uselanswer.some(option => {
                    //         if (item.finalanswer.indexOf(option) === -1) {
                    //             answerstatus = 0
                    //             return true
                    //         }
                    //     })
                    //     emitData.answerstatus = answerstatus
                    // }
                    this.$emit('handleSaveExamQuestionSuccess', emitData)
                },
                error: error => {

                }
            })
            if (this.submitAutoJump) {
                this.$emit('handleNextPage')
            }
        },
        handleRadioSelect(option, item) {
            item.uselanswer = option.optionsvalue
            this.handleRadioChange(item)
        },
        handleCheckboxSelect(option, item) {
            if (item.uselanswer.indexOf(option.optionsvalue) === -1) {
                item.uselanswer.push(option.optionsvalue)
            } else {
                let index = ''
                item.uselanswer.some((obj, i) => {
                    if (obj === option.optionsvalue) {
                        index = i
                        return true
                    }
                })
                item.uselanswer.splice(index, 1)
            }
        },
        handleRadioChange(item) {
            // 背题模式 用户选择后马上提交接口
            if (this.pattern === 2 || this.submitAutoJump) {
                this.handleSaveExamQuestionItem(item)
            }
        }
    },
    watch: {
        pattern: {
            handler(newV) {
                if (newV === 2) {
                    this.questioninfo.forEach(item => {
                        if (item.uselanswer && item.questiontype !== 2) {
                            this.handleSaveExamQuestionItem(item)
                        }
                    })
                }
            }
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-answer-area {
    .question-item {
        .questiontype-subject {
            background: #fff;
            padding: 0.28rem 0.32rem;
            box-sizing: border-box;
            border-bottom: 0.01rem solid #E5E5E5;
            .questiontype {
                line-height: 1.4;
                color: #666666;
                margin-bottom: 0.12rem;
            }
            .subject {
                line-height: 1.4;
                color: #333333;
            }
        }
        .radio-group-box {
            background: #fff;
            .radio-item {
                padding: 0.28rem 0.24rem 0.28rem 0.4rem;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                .optionsvalue {
                    width: 0.5rem;
                    height: 0.5rem;
                    border-radius: 50%;
                    background: #F3F5F7;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #666666;
                    margin-right: 0.16rem;
                }
                .optionsinfo {
                    flex: 1;
                    width: 0;
                    color: #333333;
                    line-height: 1.4;
                }
                &.active {
                    background: #F2FBFF;
                    .optionsvalue {
                        background: #1D60AD;
                        color: #fff;
                    }
                }
            }
            &.read-only {
                .radio-item {
                    .is-correct {
                        width: 0.5rem;
                        height: 0.5rem;
                        border-radius: 50%;
                        border: 0.04rem solid rgba(64,208,107,0.2);
                        box-sizing: border-box;
                        margin-right: 0.16rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .value {
                            width: 0.42rem;
                            height: 0.42rem;
                            border-radius: 50%;
                            background: #40D06B;
                            color: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    .is-error {
                        width: 0.5rem;
                        height: 0.5rem;
                        border-radius: 50%;
                        border: 0.04rem solid rgba(255,71,71,0.2);
                        box-sizing: border-box;
                        margin-right: 0.16rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .value {
                            width: 0.42rem;
                            height: 0.42rem;
                            border-radius: 50%;
                            background: #FF6666;
                            color: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    .optionsinfo {
                        &.correct {
                            color: #40D06B;
                        }
                        &.iserror {
                            color: #FF6666;
                        }
                    }
                }
            }
        }
        .submit-answer-btn-box {
            padding: 0.48rem 0;
            display: flex;
            align-items: center;
            justify-content: center;
            .submit-answer-btn {
                width: 4.6rem;
                height: 0.8rem;
                background: linear-gradient( 180deg, #59B7FF 0%, #4A80ED 100%);
                border-radius: 1rem;
                text-align: center;
                line-height: 0.8rem;
                color: #fff;
                font-size: 0.28rem;
            }
        }
        .answer-box {
            margin-top: 0.2rem;
            display: flex;
            background: #fff;
            position: relative;
            .answer-item {
                flex: 1;
                width: 0;
                text-align: center;
                padding: 0.2rem 0;
                .label {
                    color: #999999;
                    line-height: 1.4;
                    margin-bottom: 0.1rem;
                }
                .value {
                    line-height: 1.4;
                    &.is-correct {
                        color: #40D06B;
                    }
                    &.is-error {
                        color: #FF6666;
                    }
                }
            }
            &::after {
                content: '';
                position: absolute;
                width: 0.01rem;
                height: 0.7rem;
                background: #E5E5E5;
                top: 0.28rem;
                left: 50%;
            }
        }
        .analysis-box {
            margin-top: 0.2rem;
            background: #fff;
            padding: 0.28rem 0.32rem;
            box-sizing: border-box;
            .icon-title {
                display: flex;
                align-items: center;
                margin-bottom: 0.28rem;
                .icon {
                    width: 0.36rem;
                    height: 0.36rem;
                    margin-right: 0.1rem;
                }
                .title {
                    color: #333333;
                    line-height: 1.5;
                }
            }
            .quesanalysis {
                color: #666666;
                line-height: 1.4;
            }
        }
    }
}
</style>